var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.593,
    height: 23.535,
    viewBox: "0 0 20.593 23.535",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-building",
    "data-name": "Icon awesome-building",
    d: "M20.041,22.064h-.919V1.1a1.1,1.1,0,0,0-1.1-1.1H2.574a1.1,1.1,0,0,0-1.1,1.1V22.064H.552A.552.552,0,0,0,0,22.616v.919H20.593v-.919A.552.552,0,0,0,20.041,22.064ZM5.884,3.493a.552.552,0,0,1,.552-.552H8.274a.552.552,0,0,1,.552.552V5.332a.552.552,0,0,1-.552.552H6.435a.552.552,0,0,1-.552-.552Zm0,4.413a.552.552,0,0,1,.552-.552H8.274a.552.552,0,0,1,.552.552V9.745a.552.552,0,0,1-.552.552H6.435a.552.552,0,0,1-.552-.552Zm2.39,6.8H6.435a.552.552,0,0,1-.552-.552V12.319a.552.552,0,0,1,.552-.552H8.274a.552.552,0,0,1,.552.552v1.839A.552.552,0,0,1,8.274,14.709Zm3.493,7.355H8.826V18.2a.552.552,0,0,1,.552-.552h1.839a.552.552,0,0,1,.552.552Zm2.942-7.906a.552.552,0,0,1-.552.552H12.319a.552.552,0,0,1-.552-.552V12.319a.552.552,0,0,1,.552-.552h1.839a.552.552,0,0,1,.552.552Zm0-4.413a.552.552,0,0,1-.552.552H12.319a.552.552,0,0,1-.552-.552V7.906a.552.552,0,0,1,.552-.552h1.839a.552.552,0,0,1,.552.552Zm0-4.413a.552.552,0,0,1-.552.552H12.319a.552.552,0,0,1-.552-.552V3.493a.552.552,0,0,1,.552-.552h1.839a.552.552,0,0,1,.552.552Z",
    fill: "#ff6f00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.aef2b1806ad89ebadeaec5528f188e06.svg";
export { ForwardRef as ReactComponent };